export default {
    ContribuicaoAtiva: axios.create({
      baseURL: process.env.VUE_APP_ENDPOINT_API + "contribuicao-ativa"
    })
  }


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/ContribuicaoAtiva.js
// module id = rVY1
// module chunks = 32